import { Box, BoxProps } from "@chakra-ui/react"
import { forwardRef } from "react"

type RedactorContentProps = {
  content: string
} & BoxProps

// Renders content created via the (legacy) redactor editor.
// NOTE: this may be useful in general for user created richtext content.
const RedactorContent = forwardRef<HTMLDivElement, RedactorContentProps>(
  ({ content, ...props }, ref) => {
    return (
      <Box
        ref={ref}
        as="article"
        className="note-body brand-content"
        dangerouslySetInnerHTML={{ __html: content }}
        css={{
          "& ul, & ol": {
            listStyle: "initial",
            pl: "2em",
            mb: "14px"
          },
          "& ul": {
            listStyleType: "disc"
          },
          "& ol": {
            listStyleType: "decimal"
          },
          // Need to apply nested list styles. The first level is numeral
          // the second level is alpha.
          "& ol ol": {
            listStyleType: "lower-alpha"
          },
          "& ol ol ol": {
            listStyleType: "lower-roman"
          },
          "& img": {
            maxWidth: "100%",
            height: "auto"
          },
          "& pre": {
            background: "#f5f5f5",
            padding: "1em",
            borderRadius: "4px",
            overflow: "auto"
          },
          ["& table"]: {
            borderCollapse: "collapse",
            width: "100%"
          },
          ["& table td"]: {
            borderWidth: "1px",
            p: 1
          },
          // Restore default top/bottom margin on paragraphs (applied in redactor editor, keep when displaying content).
          ["& > p"]: {
            my: "1em"
          },
          // Remove default top/bottom margin on first/last paragraphs.
          ["& > p:first-of-type"]: {
            mt: 0
          },
          ["& > p:last-of-type"]: {
            mb: 0
          }
        }}
        {...props}
      />
    )
  }
)

export default RedactorContent
